import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './LinkToReceipt.styles';
import {
  fetchFuelTransactionById,
  selectFuelTransaction,
} from '../../redux/store/userData/fuelTransactions';
import { selectSelectedDrawersCount } from '../../redux/store/ui/common';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { FuelTransactionData } from '../../@types';

interface Props {
  fuelTransactionId: string;
  fuelTransaction?: FuelTransactionData;
  label: React.ReactNode;
}

const LinkToFuelTransaction: React.FC<Props> = ({
  fuelTransactionId,
  fuelTransaction,
  label,
}) => {
  const dispatch = useDispatch();
  const openedDrawersCount = useSelector(selectSelectedDrawersCount);

  const onClickHandler = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (openedDrawersCount >= 2) return;
    if (fuelTransaction) {
      dispatch(selectFuelTransaction(fuelTransaction as any));
    } else {
      dispatch(fetchFuelTransactionById(fuelTransactionId));
    }
  };

  return (
    <>
      {openedDrawersCount < 2 ? (
        <span
          className="link"
          data-testid="LinkToFuelTransaction"
          onClick={onClickHandler}
        >
          {label}
        </span>
      ) : (
        <Link
          replace={false}
          to={{
            pathname: '/dashboard',
            search: `?vm=FUEL_TRANSACTIONS&type=TABLE&pageSize=50&pageNumber=1&fuelTransactionId=${fuelTransactionId}`,
          }}
          target="_blank"
        >
          <a className="external-link-wrapper" target="_blank" rel="noreferrer">
            <span className="link">{label}</span>
            <ExportOutlined
              color="#0077be"
              style={{ fontSize: '18px', marginLeft: '10px' }}
            />
          </a>
        </Link>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToFuelTransaction;
